import React, { useState } from "react";
import CustomInput from "../../customComponents/CustomInput/CustomInput";
import landingpageimage from "./../../../Assets/images/landingPage.svg";
import axiosInstance from "../../services/api/API";
import "./Login.scss";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import EwentLogo from "../../../Assets/icons/Newtron logo_w_circle.svg";
import loginLogo from "./../../../Assets/icons/Newtron  white bg 1.png";
import ROUTES_NAVIGATION from "../../../routes/routes";

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // New state for loading
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true); // Start loading

    // Basic validation
    if (!email || !password) {
      setError("Please enter both email and password.");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.post("/login", {
        email,
        password,
      });

      // const passwordReset = response.data?.data?.loginUserData?.is_password_reset;
      // const forgot_pass_token = response.data?.data?.loginUserData?.forgot_pass_token;
      // if (passwordReset === 0) {
      //   navigate("/reset-password/:id");
      //   return;
      // }
      const passwordReset =
        response.data?.data?.loginUserData?.is_password_reset;
      const forgot_pass_token =
        response.data?.data?.loginUserData?.forgot_pass_token;

      // if (passwordReset === 0) {
      //   navigate(`/reset-password/${forgot_pass_token}`, {
      //     state: { passwordReset },
      //   });
      //   return;
      // }

      if (response.status === 200) {
        const {
          JwtToken,
          BusinessPartnerId,
          dealer_id,
          UserType,
          showroom_id,
          UserId,
          engineer_id,
          is_on_created,
          UserName,
          profileImage,
          is_partial_payment,
          is_password_reset,
        } = response.data?.data?.loginUserData;

        // Store tokens and IDs in localStorage
        localStorage.setItem("authToken", JwtToken);
        sessionStorage.setItem("u_t", JwtToken);
        localStorage.setItem("business_partner_id", BusinessPartnerId);
        localStorage.setItem("dealerId", dealer_id);
        localStorage.setItem("UserType", UserType);
        localStorage.setItem("showroom_id", showroom_id);
        localStorage.setItem("UserId", UserId);
        localStorage.setItem("engineer_id", engineer_id);
        localStorage.setItem("is_on_created", is_on_created);
        localStorage.setItem("UserName", UserName);
        localStorage.setItem("profileImage", profileImage);
        localStorage.setItem("is_partial_payment", is_partial_payment);
        localStorage.setItem("is_password_reset", is_password_reset);

        try {
          localStorage.removeItem(`notifications_shown_${UserId}`);
        } catch (e) {
          /* ignore */
        }

        // Log the user in
        login(email);
        setEmail("");
        setPassword("");
        onLogin();
        navigate("/cards", { state: { isLoggedIn: true } });
      } else {
        setError(
          "Failed to log in. Please check your credentials and try again."
        );
      }
    } catch (error) {
      console.error("Error logging in:", error);
      setError(
        error?.response?.data?.data?.message ||
          "An error occurred. Please try again later."
      );
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const forgotPasswordNavigate = () => {
    navigate(ROUTES_NAVIGATION.FORGOTPASSWORD);
  };

  return (
    <div className="mainContainer">
      <div style={{ position: "relative" }} className="parent-Container ">
        <img src={EwentLogo} alt="ewentLogo" className="image-css" />
        <div className="loginImage ">
          <img
            style={{ height: "21rem", width: "21rem", objectFit: "contain" }}
            src={loginLogo}
            alt="Login"
            className="img-fluid"
          />
        </div>
        <div className="loginContainer ">
          <h3 className="logintitle mb-3">Login Here</h3>
          <form onSubmit={handleLogin}>
            <div className="loginInputsContainer">
              <CustomInput
                placeholder="User ID"
                type="email"
                value={email}
                autoComplete="off"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <CustomInput
                placeholder="Password"
                type="password"
                value={password}
                autoComplete="off"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {error && <p className="error">{error}</p>}
              {/* <div
                style={{ cursor: "pointer" }}
                onClick={() => forgotPasswordNavigate()}
                className="forgotPassword"
              >
                Forgot Password?
              </div> */}
              <div
                
                // onClick={() => forgotPasswordNavigate()}
                className="forgotPassword"
              >
                <p style={{ cursor: "pointer" }} onClick={() => forgotPasswordNavigate()}>Forgot Password?</p>
              </div>
            </div>
            <div className="mt-3">
              <button type="submit" className="loginButton" disabled={loading}>
                {loading ? "Logging In..." : "Login"}{" "}
                {/* Change button text based on loading state */}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
